<template>
  <div
    class="notification"
    :class="{'notification--read' : !notification.is_unread}"
  >
    <div
      class="notification__button"
      role="button"
      @click="handleNotificationAction"
    >
      <picture
        class="notification__image"
        :style="{backgroundImage: `url(${notification.action.image})`}"
      ></picture>

      <div class="notification__content">
        <div class="notification__title" v-html="notification.action.title"></div>
        <div class="notification__date">{{ notification.created_at }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    props: {
      notification: { type: Object, required: true }
    },

    methods: {
      ...mapActions('slideSidebar', ['slideSidebarShow']),

      ...mapActions('notification', ['markNotificationAsRead']),

      handleNotificationAction () {
        this.trackNotificationOpenEvent()
        
        this.markNotificationAsRead(this.notification)

        if (this.notification.action.meta.type === 'custom') {
          this.slideSidebarShow({
            name: 'notification/NotificationPostSidebar',
            direction: 'right',
            props: { notification: this.notification }
          })
        } else if (this.notification.action.meta.type === 'redirect') {
          this.$router.push(this.notification.action.meta.url)
        }
      },

      trackNotificationOpenEvent () {
        this.$gtm.trackEvent({
          event: 'notifications.open-item',
          item_id: this.notification.id
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .notification {
    $p: &;

    &__button {
      display: flex;
      padding: 10px;
      border-radius: 10px;
      transition: .25s all;

      &:hover {
        background: $purple700;
      }
    }

    &__image {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      flex-grow: 0;
      background-size: cover;
      background-position: center center;
    }

    &__content {
      padding-left: 10px;
    }

    &__title {
      font-size: 0.89rem;
      line-height: 20px;;
      margin-bottom: 3px;

      ::v-deep strong {
        font-weight: 400;
        color: $highlightPrimaryColor;
      }
    }

    &__date {
      font-size: 12px;
      line-height: 20px;
      color: $white100;
    }

    &--read {
      #{$p}__title { 
        opacity: 0.7;
      }

      #{$p}__date { 
        opacity: 0.7;
      }
    }
  }
</style>